import { useInfiniteQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { reviewsApi } from '../api/reviewsApi';
import { reviewKeys } from '../queryKeys';

export type ReviewFilter = 'all' | 'unresponded';

const PAGE_SIZE = 10;

export function useReviews(filter: ReviewFilter = 'all') {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const responded = filter === 'unresponded' ? false : undefined;

  const query = useInfiniteQuery({
    queryKey: reviewKeys.list(locationId, responded),
    queryFn: ({ pageParam }) =>
      reviewsApi.getReviews(locationId, { responded, page: pageParam, limit: PAGE_SIZE }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.meta.page < lastPage.meta.totalPages ? lastPage.meta.page + 1 : undefined,
    enabled: !!locationId,
    refetchInterval: (query) => {
      const hasDrafting = query.state.data?.pages.some((page) =>
        page.data.some((review) => review.status === 'pending_draft'),
      );
      return hasDrafting ? 5000 : false;
    },
  });

  const reviews = query.data?.pages.flatMap((p) => p.data) ?? [];
  const total = query.data?.pages[0]?.meta.total ?? 0;

  return { ...query, reviews, total, filter, locationId };
}
